<div class="oo-header" [style.background-color]="ooVenue.styles?.headerBgColor" [style.color]="ooVenue.styles?.headerTextColor">
	<img
		class="oo-venue-logo"
		[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + ooVenue.venueKey + '/logo.png'"
		onError="this.src='https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/logo.jpg'"
	/>
	<div class="oo-venue-info">
		<span class="display-10" style="margin-bottom: 0.25rem"> {{ ooVenue.name }} </span>
		<div class="display-14">{{ ooVenue.address1 }}, {{ ooVenue.city }}, {{ ooVenue.state }} {{ ooVenue.zip }}</div>
		<div class="display-14">
			{{ ooVenue.phone }}
		</div>
	</div>
	<div class="disclaimer" *ngIf="!loading && !error && !message && ooVenue.disclaimer">
		<div style="max-width: 1200px" class="disclaimer-text display-14">{{ ooVenue.disclaimer }}</div>
	</div>
</div>
